// extracted by mini-css-extract-plugin
export var logo = "_cc-2";
export var logoWrapper = "_cc-1";
export var strip = "_cc-0";